import { FundCentreState } from '@/store/fundCentre/typings';

export const initialFundCentreState: FundCentreState = {
  funds: [],
  allFundsCount: 0,
  fundsInFocusCount: 0,
  searchByISIN: false,
  searchByISINResult: {},
  shareclassMappings: {},
  currentPage: 1,
  paginationMaxPages: 1,
  searchQuery: {
    id: '',
    name: '',
    isin: '',
  },
  requestPayloadAssets: {
    countryCode: '',
    investorTypes: '',
    jurisdiction: '',
    language: '',
    site: '',
  },
  requestsControllers: {
    fetchFundsOverview: undefined,
    fetchFundsPrices: undefined,
    fetchSearchResultsByISINCode: undefined,
  },
  appliedFilters: [],
  selectedDate: null,
  selectedTab: 'overview',
  fundDetailsPageUrl: '',
  activeTabKey: 0,
  error: '',
};
